import {
    baseUrl,
    isSignedIn,
    getHeaders,
    getMultipartHeaders,
} from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

export async function EntityServicesGetAllEntities(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/Entity${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServiceGetEntityById(id) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${id}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesUpdateEntity(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity`;

    return axios.put(urlApi, body, getHeaders());
}

export async function EntityServicesInactivateEntity(entityId, block = true) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/block/${block}`;

    return axios.put(urlApi, {}, getHeaders());
}

export async function EntityServicesArchivedEntity(entityId, archived = true) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/archived/${archived}`;

    return axios.put(urlApi, {}, getHeaders());
}

export async function EntityServicesCreateNewEntityAndUser(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/wizard`;

    return axios.post(urlApi, body, getHeaders());
}

export async function EntityServicesGetCompaniesDropdown() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/dropdown`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesGetCustomLayout(entityDomainId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/domain/${entityDomainId}/customization`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesUpdateCustomLayout(entityDomainId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/domain/${entityDomainId}/customization`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function EntityServicesPostUploadLogo(entityCompanyId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityCompanyId}/upload-logo`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function EntityServicesPostUploadBG(entityCompanyId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityCompanyId}/upload-background`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function EntityServicesUpdateEntityWithPhoto(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/with-upload`;

    return axios.put(urlApi, body, getMultipartHeaders());
}

export async function EntityServicesCreateEntityAndUserWithPhoto(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/wizard-upload`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function EntityServicesGetDomainsList() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/dropdown/entitydomain`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesGetUsersListByEntityId(
    entityId,
    tableFilters
) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/Entity/${entityId}/users${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesGetTestAccountConfigByEntityId(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/test-account-config`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesCreateTestAccountConfig(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/test-account-config`;

    return axios.post(urlApi, body, getHeaders());
}

export async function EntityServicesUpdateTestAccountConfig(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/test-account-config`;

    return axios.put(urlApi, body, getHeaders());
}

export async function EntityServicesGetExportEntities(entitiesId, searchText) {
    await isSignedIn();

    const query = queryFilter({ entities: entitiesId, searchText });
    const urlApi = `${baseUrl}/Entity/export-entities${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesGetQuotationIntegration(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/quotation-integration`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesGetPackBalance(entityId, body) {
    await isSignedIn();

    const query = queryFilter(body);
    const urlApi = `${baseUrl}/Entity/${entityId}/pack/balance${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesUpdateStatusEntity(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/status`;

    return axios.put(urlApi, body, getHeaders());
}

// export async function EntityServicesGetTecDocServicePackBalance(entityId) {
//     await isSignedIn();

//     const urlApi = `${baseUrl}/Entity/${entityId}/pack/tecdocservice/balance`;

//     return axios.get(urlApi, getHeaders());
// }

export async function EntityServicesGetPackageServices(entityId, filters) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Entity/${entityId}/package-services${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesCreatePackageService(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/package-service`;

    return axios.post(urlApi, body, getHeaders());
}

export async function EntityServicesGetPackageServicesById(
    entityPackageServiceId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/package-service/${entityPackageServiceId}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesUpdateEntityPackageService(
    entityPackageServiceId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/package-service/${entityPackageServiceId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function EntityServicesDeleteEntityPackageService(
    entityPackageServiceId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/package-service/${entityPackageServiceId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function EntityServicesGetPackageServicesDetails(
    entityPackageServiceId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Entity/package-service/${entityPackageServiceId}/details${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesGetPackageServicesAllDetails(
    entityPackageServiceIds,
    quotationId
) {
    await isSignedIn();

    const query = queryFilter({ entityPackageServiceIds, quotationId });
    const urlApi = `${baseUrl}/Entity/package-service/all-details${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesPutPackageServicesDetail(
    entityPackageServiceId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/package-service/${entityPackageServiceId}/detail`;

    return axios.put(urlApi, body, getHeaders());
}

export async function EntityServicesDeleteEntityPackageServiceDetail(
    entityPackageServiceDetailId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/package-service/detail/${entityPackageServiceDetailId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function EntityServicesGetEntityContactPart() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/contact/input-order-parts`;

    return axios.get(urlApi, getHeaders());
}

export async function EntityServicesTestSMTPConfigurations(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Entity/${entityId}/test-smtp-config`;

    return axios.post(urlApi, body, getHeaders());
}
